// @ts-nocheck
import React, { useEffect } from 'react';
import intl from 'react-intl-universal';

import { CarriersProvider } from './CarriersProvider';
import CarriersDataTable from './CarriersDataTable';

import withDashboardActions from '@/containers/Dashboard/withDashboardActions';

import { compose } from '@/utils';

function CarriersList({
  // #withDashboardActions
  changePreferencesPageTitle,
}) {
  useEffect(() => {
    changePreferencesPageTitle(intl.get('carriers'));
  }, [changePreferencesPageTitle]);

  return (
    <CarriersProvider>
      <CarriersDataTable />
    </CarriersProvider>
  );
}

export default compose(withDashboardActions)(CarriersList);